export const VISIBLE_PIN_IDS_MAX = 24;

function rectsOverlap(a, b) {
  if (!a || !b) return false;
  return a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y;
}

/** User-pin activity ids whose page bounds overlap the current viewport. */
export function collectVisiblePinIds(editor, { max = VISIBLE_PIN_IDS_MAX } = {}) {
  if (!editor?.getCurrentPageShapes) return [];
  const viewport = editor.getViewportPageBounds?.();
  if (!viewport) return [];
  const ids = [];
  for (const shape of editor.getCurrentPageShapes() || []) {
    if (shape?.type !== 'pin-card' || !shape.meta?.activityId) continue;
    const bounds = editor.getShapePageBounds?.(shape) || {
      x: shape.x,
      y: shape.y,
      w: shape.props?.w || 0,
      h: shape.props?.h || 0,
    };
    if (!rectsOverlap(viewport, bounds)) continue;
    ids.push(String(shape.meta.activityId));
    if (ids.length >= max) break;
  }
  return ids;
}
